// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/index.css
// module id = n4oI
// module chunks = 1